// ERP HR API — JWT 인증 포함
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8085/api';

const getHeaders = (isFormData = false) => {
  const headers = {};
  if (!isFormData) headers['Content-Type'] = 'application/json';
  const token = localStorage.getItem('token');
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};

const handleResponse = async (response, requestUrl = '') => {
  const isLoginAttempt = typeof requestUrl === 'string' && requestUrl.includes('/auth/login');

  if (response.status === 401) {
    const errorData = await response.json().catch(() => ({}));
    if (!isLoginAttempt) {
      localStorage.removeItem('token');
      window.dispatchEvent(new Event('tokenChanged'));
      window.location.href = '/login';
    }
    const error = new Error(errorData.message || 'Unauthorized');
    error.status = 401;
    error.data = errorData;
    throw error;
  }

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    const error = new Error(errorData.Msg || errorData.message || `HTTP error! status: ${response.status}`);
    error.status = response.status;
    error.data = errorData;
    throw error;
  }
  return response;
};

const api = {
  get: async (url, config = {}) => {
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: getHeaders(),
      credentials: 'include',
      ...config,
    });
    const handled = await handleResponse(response, fullUrl);
    return { data: await handled.json(), status: handled.status };
  },
  /** 이미지 등 바이너리 조회 (JWT 헤더 포함) */
  getBlob: async (url, config = {}) => {
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const response = await fetch(fullUrl, {
      method: 'GET',
      headers: getHeaders(true),
      credentials: 'include',
      ...config,
    });
    if (response.status === 404) {
      return { data: null, status: 404 };
    }
    const handled = await handleResponse(response, fullUrl);
    return { data: await handled.blob(), status: handled.status };
  },
  post: async (url, data, config = {}) => {
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify(data),
      credentials: 'include',
      ...config,
    });
    const handled = await handleResponse(response, fullUrl);
    return { data: await handled.json(), status: handled.status };
  },
  /** multipart/form-data (Content-Type 자동 설정) */
  postForm: async (url, formData, config = {}) => {
    const fullUrl = url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
    const response = await fetch(fullUrl, {
      method: 'POST',
      headers: getHeaders(true),
      body: formData,
      credentials: 'include',
      ...config,
    });
    const handled = await handleResponse(response, fullUrl);
    return { data: await handled.json(), status: handled.status };
  },
};

export { API_BASE_URL };
export default api;
